import { useState } from 'react';
import { Download, FileText, Shield, Loader2 } from 'lucide-react';
import { profilerApi } from '@/api/profiler';

interface Props {
  caseId: string;
  caseRef?: string;
  userRole?: string;
  disabled?: boolean;
}

function triggerDownload(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function ReportDownloadBar({ caseId, caseRef, userRole, disabled }: Props) {
  const [loadingAml, setLoadingAml] = useState(false);
  const [loadingDossier, setLoadingDossier] = useState(false);
  const canDossier = userRole === 'senior_analyst' || userRole === 'admin';

  async function download(track: 'aml' | 'dossier') {
    if (track === 'aml') setLoadingAml(true);
    else setLoadingDossier(true);
    try {
      const blob = await profilerApi.downloadReport(caseId, track);
      const ref = caseRef ?? caseId;
      triggerDownload(blob, `sycek_${track}_${ref}.pdf`);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'Download failed';
      alert(msg);
    } finally {
      if (track === 'aml') setLoadingAml(false);
      else setLoadingDossier(false);
    }
  }

  const btnBase =
    'inline-flex items-center gap-2 px-3 py-2 rounded-lg text-[10px] font-mono font-bold tracking-wider transition-all disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <button
        className={`${btnBase} border`}
        style={{
          background: '#002733', borderColor: '#00C8FF44', color: '#00C8FF',
        }}
        disabled={disabled || loadingAml}
        onClick={() => download('aml')}
      >
        {loadingAml ? <Loader2 size={12} className="animate-spin" /> : <FileText size={12} />}
        AML REPORT PDF
      </button>

      {canDossier ? (
        <button
          className={`${btnBase} border`}
          style={{ background: '#1A032A', borderColor: '#C026D344', color: '#C026D3' }}
          disabled={disabled || loadingDossier}
          onClick={() => download('dossier')}
        >
          {loadingDossier ? <Loader2 size={12} className="animate-spin" /> : <Download size={12} />}
          FULL DOSSIER PDF
        </button>
      ) : (
        <button
          className={`${btnBase} border cursor-not-allowed opacity-40`}
          style={{ background: '#1A032A', borderColor: '#C026D322', color: '#C026D3' }}
          disabled
          title="Requires Senior Analyst role"
        >
          <Shield size={12} />
          FULL DOSSIER PDF
        </button>
      )}
    </div>
  );
}
